import { createPolymorphicComponent, Box as MantineBox } from "@mantine/core";
import { forwardRef } from "react";
import styles from "./box.module.scss";
import type { IProps } from "./box.types";
import classnames from "classnames";

const Box = createPolymorphicComponent<"div", IProps>(
    forwardRef<HTMLDivElement, IProps>(function BoxRenderFunction({ className, ...otherProps }, ref) {
        return <MantineBox ref={ref} className={classnames(className, styles["container"])} {...otherProps} />;
    })
);

export { Box };
